import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { UploadBundlesStartAction } from '../actions/UploadBundlesActions';
import UploadBundlesRequestHelper from '../utils/UploadBundlesRequestHelper';

export async function uploadBundles(action: UploadBundlesStartAction) {
  const toaster = ToasterService.instance;

  try {
    await UploadBundlesRequestHelper.uploadBundlesRequest(action);
    toaster.pop({
      type: ToastType.Success,
      text: FeatureFlags.salesforceBundlesUIImprovements ? Messages.connectToSalesforce_bundleUploadStartedSuccessMessageUIImprovements()
      : Messages.connectToSalesforce_bundleUploadStartedSuccessMessage(),
      keepOnLocationChange: true,
      actionHref: action.myContentUrl,
      actionMessage: Messages.connectToSalesforce_goToMyContent(),
    });
  } catch (error) {
    toaster.pop({
      type: ToastType.Error,
      text: Messages.connectToSalesforce_errorTryAgain(),
      keepOnLocationChange: true,
    });
  }
}
